import React from 'react';
import { cn } from '../../../utils/classnames';

const AssetStatusBadge = ({ status, tStatus }) => {
  const statusMap = {
    active: 'bg-blueLightest text-tealDeep',
    closed: 'bg-yellowExtraLight text-yellowMedium',
    sale: 'bg-redExtraLight3 text-redSoft',
    inactive: 'bg-redExtraLight3 text-redSoft',
  };

  const statusClass = statusMap[status] || 'bg-gray-100';

  return (
    <span
      className={cn(
        'inline-flex px-3 text-white py-1 rounded-full items-center justify-center text-xs uppercase font-semibold',
        statusClass
      )}
    >
      {tStatus?.toUpperCase() || 'N/A'}
    </span>
  );
};

export default AssetStatusBadge;
